<div class="page">
    <app-header title="{{ 'organizationsModule.title' | translate }}"> </app-header>
    <ngx-loading [show]="showSpinner"></ngx-loading>
    <div class="page-content">
        <div class="table-body">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr class="table-names">
                        <th>{{ "denomination" | translate }}</th>
                        <th>{{ "idSintra" | translate }}</th>
                        <th>{{ "usersModule.editUsers" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let organization of organizations; let i = index">
                        <th>{{ organization.name}}</th>
                        <th>{{ organization.code }}</th>
                        <th class="text-center">
                            <div class="custom-control custom-switch">
                                <a [routerLink]="['usersByOrganization', organization.id]">
                                    <app-button icon="fa-chevron-right" [disable]="false" style="display: inline-block;">
                                    </app-button>
                                  </a>
                                <!-- <app-button icon="fa-chevron-right" (buttonClick)="editUsersClick(organization)"
                                    [disable]="false"
                                    style="display: inline-block;">
                                </app-button> -->
                            </div>
                        </th>                   
                    </tr>
            </table>
        </div>
        <app-pagination 
        [options]="options" 
        [pagedList]="organizationGrid.apiEnabledOrganizations"
        [callback]="loadData"
        ></app-pagination>
    </div>

    <!-- <div class="page-content">
        <!-- <div class="table-top">
            <div class="section-header">{{ "organizationsModule.title" | translate }}</div>
            <app-button *ngIf="isVisible" [title]="'organizationsModule.addOrganization' | translate" (buttonClick)="addNewUser()"
                        icon="fa-plus">
            </app-button>
        </div> -->

        <!-- <div class="table-body">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr class="table-names">
                        <th>{{ "denomination" | translate }}</th>
                        <th>{{ "usersModule.firstAndLastName" | translate }}</th>
                        <th>{{ "usersModule.email" | translate }}</th>
                        <th>{{ "status" | translate }}</th>
                        <th>{{ "actions" | translate }}</th> -->
                        <!-- <th>{{ "usersModule.notificate" | translate }}</th> -->
                    <!-- </tr> -->
                <!-- </thead>
                <tbody>
                    <tr *ngFor="let organization of organizationInvites; let i = index">
                        <th>{{ organization.organizationName }}</th>
                        <th>{{ organization.fullName }}</th>
                        <th>{{ organization.email }}</th>
                        <th class="text-center">
                            {{ translate.instant(organization.currentStatus) }}
                        </th>
                        <th class="text-center">
                            <div class="custom-control custom-switch"
                                 *ngIf="shouldBlockUnblockUserOptionBeShown(organization)"
                                 [title]="blockUnblockMessageTooltipTitle(organization)"
                                 (click)="blockUnblockUser(organization)">
                                <input type="checkbox" class="custom-control-input " id="switch{{ i }}"
                                       [checked]="organization.currentStatus == userStatus.Registered || organization.currentStatus == userStatus.ToBeConfirmed"
                                       disabled />
                                <label class="custom-control-label cursor-pointer" for="switch{{ i }}" disabled></label>
                            </div>
                            <div *ngIf="(organization.currentStatus == userStatus.ToBeConfirmed) && organizationInvitesGrid.isOriginatorUser">
                                <app-button icon="fa-check" [disable]="organization.confirmUserIWSignatureInProgress"
                                            [info]="confirmUserMessageTooltipTitle(organization)"
                                            (buttonClick)="confirmUser(organization)">
                                </app-button>
                            </div>

                            <app-button icon="fa-trash" (click)="removeUser(organization)"
                                        *ngIf="shouldEliminateUserOptionBeShown(organization)"
                                        [info]="translate.instant('usersModule.eliminateUserTitle')"></app-button>
                        </th>  -->
                        <!-- <th class="text-center">
                            <input type="checkbox" *ngIf="shouldNotificationOptionBeShown(organization)"
                                   [(ngModel)]="organization.shouldBeNotified"
                                   [disabled]="isNotificationDisabled(organization)" />
                        </th> -->
                    <!-- </tr>
            </table>
        </div>
        <app-pagination 
        [options]="options" 
        [pagedList]="organizationInvitesGrid.apiEnabledInvites"
        [callback]="loadData"
        ></app-pagination> -->
        <!-- <div class="table-bottom">
            <app-button primary="true" [title]="'usersModule.notifyUsers' | translate"
                        (buttonClick)="notifyUsers()" [disable]="!isPossibleToNotify()">
            </app-button>
        </div> -->
    <!-- </div> -->

</div>